export default {
  CLIENT_NAME: window._env_?.REACT_APP_CLIENT_NAME ?? 'AmatriumGPT',
  BACKEND_URL: window._env_?.REACT_APP_BACKEND_API ?? 'http://localhost:8080',
  KEYCLOAK_URL: window._env_?.REACT_APP_CHAT_GPT_KEYCLOAK_URL ?? 'https://iam.amatrium.com',
  KEYCLOAK_REALM: window._env_?.REACT_APP_CHAT_GPT_KEYCLOAK_REALM ?? 'amatrium-chatgpt',
  KEYCLOAK_CLIENT_ID: window._env_?.REACT_APP_CHAT_GPT_KEYCLOAK_CLIENT_ID ?? 'amatrium-frontend',
};
